import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import ServicesTable from "components/Doobi/Services";

const ServicesRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Services" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={ServicesTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default ServicesRoute;
